import Vue from 'vue';
import { loadTileArcGIS } from '@/utils/helps';
import appConfig from 'appConfig';
import { gettotalBylayername, getAttributeBylayername } from '@/api/index';
// import BottomProperty from '../../view/Bottomshow/BottomProperty.vue';
export default {
  name: 'LayerTree',
  data() {
    return {
      layersData: [],
      currentSelects: [],
      contextData: {}, //右键选中的数据
      pagetotal: '', //当前查询的图层的总数
      dataparam: {}, //查询条件
      ledendModal: false,
      legendData: '',
      DisplayField: '', //设置图例字段
      DisplayId: '',
      layerlengedname: '',
      legendctrl: 'hide',
      totalField: [],
      CqlFilter: null,
      databaseQuery: false,
    };
  },
  components: {
    // BottomProperty,
  },
  computed: {},
  props: {
    value1: {
      type: Number,
      default: 20,
    },
  },
  watch: {
    // 监听存储图层的这个数组
    layersData(newdata) {
      this.$emit('layer-list-change', newdata);
    },
  },
  computed: {
    reverseSum() {
      return this.layersData.reverse();
    },
  },
  mounted() {
    $('#layer-all').draggable({ cancel: '#layer-pop' });

    let that = this;
    // 图层拖拽移动
    var lastIndex = 0;
    $('#layer-pop').sortable({
      cancel: '.slider1',
      start: function(event, ui) {
        lastIndex = $(ui.item).index();
      },
      stop: function(evt, ui) {
        var currentIndex = $(ui.item).index();
        var layers = that.olmap.getLayers().array_;
        var lis = $('#layer-pop ul');
        var zindex = 501;

        // var currentLayerId= lis.eq(currentIndex).find("li").attr("data-id");
        // var index = that.layersData.map(function (item) { return item.id; }).indexOf(layerid);
        for (var i = 0; i < lis.length; i++) {
          var li = lis.eq(i);
          var layerid = li.find('li').attr('data-id');
          // 图层顺序
          for (var j = 0; j < layers.length; j++) {
            if (layers[j].get('id') == '_layertree_' + layerid) {
              layers[j].setZIndex(zindex--);
            }
          }
        }
        if (currentIndex < lastIndex) {
          that.layersData.splice(currentIndex, 0, that.layersData[lastIndex]); //先增加
          that.layersData.splice(lastIndex + 1, 1); //再删除原来的
        } else {
          that.layersData.splice(currentIndex + 1, 0, that.layersData[lastIndex]);
          that.layersData.splice(lastIndex, 1);
        }
      },
    });
    $('#layer-pop .slider1').disableSelection();
    this.$bus.on('selectLayer', value => {
      var datas = JSON.parse(JSON.stringify(value));
      // datas.forEach(res => {
      //   for (let i = 0; i < that.layersData.length; i++) {
      //     const elem = that.layersData[i];
      //     if (elem.id == res.id) {
      //       res.value = elem.value; //显隐状态
      //       res.checked = elem.checked; //选中状态
      //       break;
      //     }
      //   }
      // })
      // that.layersData = datas.reverse();
      var newdata = this.compare(that.layersData, datas); //当前的数组比传过来的数组添加了多少，删除几个
      var addList = newdata.add;
      var delList = newdata.del;
      addList.forEach(res => {
        that.layersData.unshift(res);
      });
      delList.forEach(de => {
        let i = that.layersData.length;
        while (i--) {
          if (that.layersData[i].id == de.id) {
            that.layersData.splice(i, 1);
          }
        }
      });
      that.layersData.forEach(item => {
        item.value = 100;
      });
    });
    this.$bus.off('openLengend');
    this.$bus.on('openLengend', item => {
      this.showlegend(item);
    });
  },
  created() {},
  methods: {
    compare(beforeArr, afterArr) {
      let resObj = {
          add: [],
          del: [],
        },
        cenObj = {};
      //把beforeArr数组去重放入cenObj
      for (let i = 0; i < beforeArr.length; i++) {
        cenObj[beforeArr[i].id] = beforeArr[i];
      }
      //遍历afterArr，查看其元素是否在cenObj中
      for (let j = 0; j < afterArr.length; j++) {
        if (!cenObj[afterArr[j].id]) {
          resObj.add.push(afterArr[j]);
        } else {
          delete cenObj[afterArr[j].id];
        }
      }
      for (var k in cenObj) {
        resObj.del.push(cenObj[k]);
      }
      return resObj;
    },
    closelegendall() {
      let that = this;
      // 关闭全部图例
      this.legendData.forEach(function(elem) {
        if (elem.legend && elem.legend.length > 0) {
          elem.legend.forEach(function(elems) {
            elems['check'] = false;
          });
        }
      });
      this.legendctrl = 'show'; //隐藏显示全部按钮
      // 判断条件
      var where = null;
      var str = '';
      if (this.legendData && this.legendData.length > 0) {
        this.legendData[0].legend.forEach(function(elem) {
          if (str == '' && !elem.check) {
            str += that.DisplayField + '<>' + "'" + elem.label + "'";
          } else if (!elem.check) {
            str += ' And ';

            str += that.DisplayField + '<>' + "'" + elem.label + "'";
          }
        });

        var arr = this.olmap.getLayers().array_;
        var index = 500;
        for (var i = arr.length - 1; i >= 0; i--) {
          var layer = arr[i];
          var id = layer.get('id');
          if ('_layertree_' + this.DisplayId == id) {
            // 进行出图操作
            var params = layer.getSource().getParams();

            // <> 不等于
            // =等于
            // and且
            var where1 = {};
            if (str != '') {
              var def =
                that.layerlengedname || that.layerlengedname == 0
                  ? that.layerlengedname
                  : params.layers;
              where1[def] = str;
              params['layerDefs'] = JSON.stringify(where1);
              // where1[params.layers] = this.DisplayField + "<>" + "'" + aitm.label + "'";
              // params["layerDefs"] = JSON.stringify(where1)
            } else {
              if (params['layerDefs']) {
                delete params['layerDefs'];
              }
            }

            layer.getSource().updateParams(params);
            break;
          }
        }
      }
    },
    showlegendall() {
      this.legendData.forEach(function(elem) {
        if (elem.legend && elem.legend.length > 0) {
          elem.legend.forEach(function(elems) {
            elems['check'] = true;
          });
        }
      });

      this.legendctrl = 'hide'; //隐藏显示全部按钮
      var arr = this.olmap.getLayers().array_;
      for (var i = arr.length - 1; i >= 0; i--) {
        var layer = arr[i];
        var id = layer.get('id');
        if ('_layertree_' + this.DisplayId == id) {
          // 进行出图操作
          var params = layer.getSource().getParams();
          if (params['layerDefs']) {
            delete params['layerDefs'];
          }
          layer.getSource().updateParams(params);
          break;
        }
      }
    },
    showlegendfilter(itm, aitm) {
      let that = this;

      if (aitm.check) {
        aitm.check = false;
      } else {
        aitm.check = true;
      }

      // 判断条件
      var where = null;
      var str = '';
      var ctrl = true;
      itm.legend.forEach(function(elem) {
        if (str == '' && !elem.check) {
          ctrl = false;
          str += that.DisplayField + '<>' + "'" + elem.label + "'";
        } else if (!elem.check) {
          ctrl = false;
          str += ' And ';

          str += that.DisplayField + '<>' + "'" + elem.label + "'";
        }
      });

      if (ctrl) {
        // 无被勾选的图例，则隐藏全部按钮出现
        this.legendctrl = 'hide'; //隐藏显示全部按钮
      } else {
        this.legendctrl = 'show'; //隐藏显示全部按钮
      }

      var arr = this.olmap.getLayers().array_;
      var index = 500;
      for (var i = arr.length - 1; i >= 0; i--) {
        var layer = arr[i];
        var id = layer.get('id');
        if ('_layertree_' + this.DisplayId == id) {
          // 进行出图操作
          var params = layer.getSource().getParams();

          // <> 不等于
          // =等于
          // and且
          var where1 = {};
          if (str != '') {
            var def =
              that.layerlengedname || that.layerlengedname == 0
                ? that.layerlengedname
                : params.layers;
            where1[def] = str;
            params['layerDefs'] = JSON.stringify(where1);
            // where1[params.layers] = this.DisplayField + "<>" + "'" + aitm.label + "'";
            // params["layerDefs"] = JSON.stringify(where1)
          } else {
            if (params['layerDefs']) {
              delete params['layerDefs'];
            }
          }

          // var where1 = {};
          // where1[params.layers] = this.DisplayField + "=" + "'" + aitm.label + "'";
          // params["layerDefs"] = JSON.stringify(where1)
          // if(spatialFilter != null){
          //   params["spatialFilter"] = JSON.stringify(spatialFilter)
          // }

          layer.getSource().updateParams(params);
          break;
        }
      }
    },
    // 隐藏展示图例框
    hidelegend() {
      this.ledendModal = false;
    },
    // 隐藏展示图层框
    hidelayer() {
      this.$emit('childFn', false);
    },
    // 展示属性信息
    showproperty(item) {
      // 判断图层类型
      if (item.type != 'layer.VectorgeoServeRest' && item.type != 'layer.ImageGeoServerTilAndVec') {
        this.$Message.warning('当前图层不支持属性查询');
        return;
      }
      // geoserver属性查询
      if (
        (item.type.indexOf('VectorgeoServeRest') >= 0 ||
          item.type.indexOf('ServerTilAndVec') >= 0) &&
        !item.tablename
      ) {
        this.spaQ_geoServer(item, 0);
      } else {
        this.databaseQuery = true;
        this.setCenterlayer(item);
      }
    },
    //图层定位
    async setCenterlayer(record) {
      var extentList = [];
      var _this = this;
      let res = await this.publicMethod.getlayerXML(record.url);
      if (res) {
        $(res)
          .find('Layer')
          .find('Layer')
          .each(function() {
            var item = $(this);
            if (item.find('Name').text() == record.layername.split(':')[1]) {
              extentList.push(
                Number(item.find('BoundingBox').attr('minx')),
                Number(item.find('BoundingBox').attr('miny')),
                Number(item.find('BoundingBox').attr('maxx')),
                Number(item.find('BoundingBox').attr('maxy'))
              );

              _this.olmap.getView().fit(extentList);
              _this.$bus.emit('nowLayerData', record);
              if (_this.databaseQuery) {
                _this.spaQ_database(record);
              }
            }
          });
      }
    },

    /**
     * @author zt
     * @date 2020.11.23
     * @description 展示图层的图例
     */
    async showlegend(item) {
      if (item.type != 'layer.VectorgeoServeRest') {
        this.$Message.warning('当前图层不支持图例查看');
        return;
      }
      this.ledendModal = true;
      $('legendTree').draggable(); //图层可拖拽
      this.legendData = `/geoserver/wms?request=GetLegendGraphic&format=image/png&layer=${item.layername}`;
    },
    /*
     *@description:
     *@author: qqjuanqq
     *@date: 2023-03-22 10:36:02
     *@version: V1.0.0
    */
    deleteLayer(item, index){
      if (item.checked) {
        var id = "_layertree_" + item.id;
        var layers = this.olmap.getLayers();
        //如果图层存在，则移除
        var arr = [];
        layers.forEach(function (sublayer, i) {
          if (sublayer != undefined && sublayer.getProperties().id === id) {
            arr.push(sublayer);
          }
        });
        // 清除当前图层
        for (var i = 0; i < arr.length; i++) {
          this.olmap.removeLayer(arr[i]);
        }
      }
      item.checked = false; //勾选变成false
      item.checkshow = false; //勾选变成false
      this.layersData.splice(index, 1);
      var itm = {
        item: item,
        layersData: this.layersData
      }
      // 再移除数组
      this.olmap.selecLayers = this.layersData;   //选中图层 全局变量
      // this.$bus.emit("cancelAnalysis" , this.layersData); // add by qqjuanqq  2022-01-08 抛事件给分析模块
      this.$bus.emit("getSelectLayer", itm); //发送数据
    },
    /*
     *@description: 批量删除
     *@author: qqjuanqq
     *@date: 2023-03-22 10:42:48
     *@version: V1.0.0
    */
    deleteAllLayer(){
      var arr = this.olmap.getLayers().array_ //获取所有图层数据
      var arrss = JSON.parse(JSON.stringify(this.olmap.selecLayers))
      for (let i = arrss.length - 1; i >= 0; i--) {
        if (arrss[i].checked) {
          // 删除地图图层 start
          var idLay = "_layertree_" + arrss[i].id;
          for (var j = 0; j < arr.length; j++) {
            var layer = arr[j]
            var id = layer.get('id')
            if (id == idLay) {
              this.olmap.removeLayer(layer)
            }
          }
          // 删除图层 end
          arrss[i].checked = false; //勾选变成false
          arrss[i].checkshow = false; //勾选变成false
          var itm = {
            item: arrss[i],
            layersData: arrss
          }
          arrss.splice(i, 1);
          // 再移除数组
          this.$bus.emit("getSelectLayer", itm); //发送数据
        }
      }
      this.layersData = arrss;
      this.olmap.selecLayers = arrss;   //选中图层 全局变量
      // this.$bus.emit("cancelAnalysis", arrss); // add by qqjuanqq  2022-01-08 抛事件给分析模块
    },
    /**
     * @author zt
     * @date 2020.11.23
     * @description 删除
     */
    removes(item, index) {
      //图层显示与否
      if (item.layershow) {
        // 图层显示，先移除
        var id = '_layertree_' + item.id;
        var layers = this.olmap.getLayers();
        //如果图层存在，则移除
        var arr = [];
        layers.forEach(function(sublayer, i) {
          if (sublayer != undefined && sublayer.getProperties().id === id) {
            arr.push(sublayer);
          }
        });

        for (var i = 0; i < arr.length; i++) {
          this.olmap.removeLayer(arr[i]);
        }
      }
      item.checked = false;
      var itm = {
        item: item,
        layersData: this.layersData,
      };
      // var nodes = this.$refs.menutree.getCheckNodes()
      // 再移除数组
      this.layersData.splice(index, 1);
      this.olmap.selecLayers = this.layersData; //选中图层 全局变量
      this.$bus.emit('getSelectLayer', itm); //发送数据
    },
    sliderLayer(data) {
      //滑块的值

      let id = '_layertree_' + data.id;
      let vals = data.value;
      //获取当前滑动的图层，并设置透明度
      this.olmap.getLayers().forEach(function(layer) {
        if (id == layer.get('id')) {
          layer.setOpacity(vals / 100);
          return;
        }
      });
    },

    ChangeLayer(item) {
      var id = '_layertree_' + item.id;
      var layers = this.olmap.getLayers();
      //如果图层存在，则移除
      var arr = [];
      layers.forEach(function(sublayer, i) {
        if (sublayer != undefined && sublayer.getProperties().id === id) {
          arr.push(sublayer);
        }
      });

      if (item.checked) {
        item.checked = true;
        for (var i = 0; i < arr.length; i++) {
          arr[i].setVisible(true);
        }
      } else {
        item.checked = false;
        // 移除
        for (var i = 0; i < arr.length; i++) {
          // this.olmap.removeLayer(arr[i]);
          arr[i].setVisible(false);
        }
      }
      return;
    },
    //移除图层
    clearLayer() {
      var arr = [];
      var overlayer = [];
      var layers = this.olmap.getLayers();
      var overlaypopu = this.olmap.getOverlays();
      //只移除图层列表中的图层
      layers.forEach(function(sublayer, i) {
        if (
          sublayer != 'undefined' &&
          sublayer.getProperties().id !== 'baseFontLayer' &&
          sublayer.getProperties().id !== 'baseVectorLayer' &&
          sublayer.getProperties().id !== 'baseImgTLayer' &&
          sublayer.getProperties().id !== 'baseLayer'
        )
          arr.push(sublayer);
      });
      overlaypopu.forEach(function(popu, i) {
        overlayer.push(popu);
      });
      for (var i = 0; i < overlayer.length; i++) {
        this.olmap.removeOverlay(overlayer[i]);
      }
      for (var i = 0; i < arr.length; i++) {
        this.olmap.removeLayer(arr[i]);
      }
    },
    // 通用arcgis查询
    async spaQ_geoServer(datainfo, pageindex) {
      datainfo.TypeName = datainfo.layername;
      datainfo.SrsName = appConfig.map.proj;
      datainfo.startIndex = pageindex;
      datainfo.maxFeatures = 10;
      var pjsonResult = await this.publicMethod.geoServerQuery(
        datainfo.urlL,
        datainfo,
        this.$olmap
      );
      this.pagetotal = pjsonResult.resultData.totalFeatures; //总条数复制
      if (this.pagetotal === 0) {
        this.$Message.warning('查询结果为空');
        return;
      }
      this.$bus.emit('spinShow', true);
      if (
        pjsonResult.resultData &&
        pjsonResult.resultData.features &&
        pjsonResult.resultData.features.length > 0
      ) {
        var fea = {
          features: pjsonResult.featureArr,
          contextData: datainfo,
          total: this.pagetotal,
          spinShow: false,
          dataparam: datainfo, //查询条件
          totalField: this.totalField, //属性字段类型
        };
        this.$bus.emit('queryData', fea);
      } else {
        this.$bus.emit('queryData', null);
        this.$Message.info('暂无数据!');
      }
    },
    //数据库查询
    spaQ_database(datainfo) {
      this.getJsonArr();
      let geometriesParams = {
        type: 'MultiPolygon',
        coordinates: this.CqlFilter,
      };
      var params = {
        sr: '4326',
        type: '2',
        pageSize: 10,
        pageNum: 0,
        queryParam: '',
        indicate: datainfo.tablename,
        geometriesParams: JSON.stringify(geometriesParams),
      };
      let that = this;
      this.$bus.emit('closebottom', null);
      // http://192.168.1.113:8889/geoserverplugin/wps/getGeoserverQuery
      $.ajax({
        type: 'post',
        url: '/zituSpace/wps/getGeoserverQuery',
        // dataType: 'json',
        contentType: 'application/json; charset=UTF-8',
        data: JSON.stringify(params),
        success: function(res) {
          if (res.code == 200 && res.success) {
            let featureArr = [];
            if (res.result.features.length > 0) {
              res.result.features.forEach((item, index) => {
                var geojson_format = new that.$olmap.format.GeoJSON();
                let featureObj = geojson_format.readFeature(item.geometry);
                featureObj.values_ = Object.assign(featureObj.values_, item.properties);
                featureArr.push(featureObj);
              });
            }
            if (featureArr.length > 0) {
              var count = res.result.totalFeatures; //总条数
              var fea = {
                features: featureArr,
                contextData: datainfo,
                total: count,
                spinShow: false,
                dataparam: params, //查询条件
                queryType: '2',
              };
              that.databaseQuery = false;
              that.$bus.emit('spinShow', true);
              that.$bus.emit('queryData', fea);
            } else {
              that.databaseQuery = false;
              that.$Message.info('暂无数据！');
              that.$bus.emit('closebottom', null);
            }
          }
        },
        error: function(e) {},
      });
    },
    //取当前容器的可视区域的范围；
    getJsonArr() {
      var extentObject = this.olmap.getView().calculateExtent(this.olmap.getSize());

      var jsonArr = `[[${Number(extentObject[0])},${Number(extentObject[1])}],[${Number(
        extentObject[2]
      )},${Number(extentObject[1])}],[${Number(extentObject[2])},${Number(
        extentObject[3]
      )}],[${Number(extentObject[0])},${Number(extentObject[3])}],[${Number(
        extentObject[0]
      )},${Number(extentObject[1])}]]`;
      this.CqlFilter = [[JSON.parse(jsonArr)]];
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/layertree/LayerTree.js